import { withNestedView } from '@/router/routerHelpers';
const loadView = withNestedView('settings');

import { PERMISSIONS } from '@/access/permissions';
import { FEATURES } from '@/access/features';

const settingsRoutes = [
  {
    path: '/settings',
    component: {
      render: (c) => c('router-view'),
    },
    children: [
      {
        path: '',
        meta: { showNav: true },
        component: loadView('Settings'),
        children: [
          {
            path: 'profile',
            name: 'settings-profile',
            component: loadView('users/components/UserEditForm'),
          },
          {
            path: 'users',
            name: 'settings-users',
            meta: {
              feature: FEATURES.USERS,
              permission: PERMISSIONS.READ_USERS,
            },
            component: loadView('users/UsersMain'),
          },
          {
            path: 'archived-users',
            name: 'settings-archived-users',
            props: { archived: true },
            meta: {
              feature: FEATURES.ARCHIVED_USERS,
              permission: PERMISSIONS.READ_USERS,
            },
            component: loadView('users/UsersMain'),
          },
          {
            path: 'account',
            name: 'settings-account',
            meta: {
              feature: FEATURES.ACCOUNT,
            },
            component: loadView('account/Account'),
          },
          {
            path: 'snippets',
            name: 'settings-snippets',
            redirect: { name: 'snippets' },
          },
          {
            path: 'fields',
            name: 'settings-fields',
            meta: {
              feature: FEATURES.FIELDS,
            },
            component: loadView('fields/FieldsMain'),
          },
          {
            path: 'links',
            name: 'settings-links',
            meta: {
              feature: FEATURES.LINKS,
            },
            component: loadView('links/SettingsLinks'),
          },
          {
            path: 'portal',
            name: 'settings-portal',
            component: loadView('portal/SettingsPortal'),
          },
          {
            path: 'integrations',
            name: 'settings-integrations',
            meta: {
              feature: FEATURES.INTEGRATIONS,
            },
            component: loadView('integrations/Integrations'),
          },
          {
            path: 'email-templates',
            name: 'settings-email-templates',
            meta: {
              feature: FEATURES.EMAIL_TEMPLATES,
            },
            component: loadView('emailTemplates/EmailTemplatesMain'),
          },
          {
            path: 'email-addresses',
            name: 'settings-email-addresses',
            meta: {
              feature: FEATURES.EMAIL_ADDRESSES,
            },
            component: loadView('emailAddresses/EmailAddressesMain'),
          },
          {
            path: 'business',
            name: 'settings-business',
            meta: {
              feature: FEATURES.OTHER_SETTINGS,
            },
            component: loadView('other/SettingsBusiness'),
          },
          {
            path: 'conversations',
            name: 'settings-conversations',
            component: loadView('other/SettingsConversations'),
          },
          {
            path: 'other/:section?',
            props: true,
            name: 'settings-other',
            meta: { feature: FEATURES.SETTINGS },
            component: loadView('other/SettingsOther'),
          },
          {
            path: 'backend',
            name: 'settings-backend',
            component: loadView('backend/SettingsBackend'),
          },
          {
            path: 'compliance',
            name: 'settings-compliance',
            component: loadView('compliance/SettingsCompliance'),
          },
          {
            path: 'teams',
            name: 'settings-teams',
            props: true,
            component: loadView('teams/Teams'),
            meta: {
              feature: FEATURES.TEAMS,
              permission: PERMISSIONS.TEAMS,
            },
          },
          {
            path: 'tags',
            name: 'settings-tags',
            props: true,
            component: loadView('tags/Tags'),
            meta: {
              feature: FEATURES.TAGS,
              permission: PERMISSIONS.TAGS,
            },
          },
          {
            path: 'custom-objects',
            name: 'settings-custom-objects',
            props: true,
            meta: {
              feature: FEATURES.CUSTOM_OBJECTS,
            },
            redirect: { name: 'custom_objects' },
          },
          {
            path: 'permissions',
            name: 'settings-permissions',
            props: true,
            meta: {
              permission: PERMISSIONS.UPDATE_USERS,
              feature: FEATURES.USER_PERMISSIONS,
            },
            component: loadView('permissions/AllUsersPermissions'),
          },
          {
            path: 'roles',
            name: 'settings-roles',
            meta: {
              feature: 'user_permissions',
            },
            component: loadView('roles/RolesList'),
          },
        ],
      },
      {
        path: 'teams/:team_id',
        name: 'settings-team-edit',
        props: true,
        meta: {
          feature: FEATURES.TEAMS,
          permission: PERMISSIONS.TEAMS,
        },
        component: loadView('teams/TeamEdit'),
      },
      {
        path: 'integrations/:type',
        name: 'integration-edit',
        props: true,
        meta: {
          feature: FEATURES.INTEGRATIONS,
        },
        component: loadView('integrations/IntegrationEdit'),
      },
      {
        path: 'custom-objects/:id',
        name: 'settings-custom-object-edit',
        props: true,
        meta: { feature: FEATURES.CUSTOM_OBJECTS },
        redirect: { name: 'custom-object-edit' },
      },
      {
        path: 'custom-objects/:id/import',
        name: 'settings-custom-object-import',
        props: true,
        meta: { feature: FEATURES.CUSTOM_OBJECTS },
        redirect: { name: 'custom-object-import' },
      },
      {
        path: 'roles/new',
        name: 'settings-role-create',
        meta: { feature: 'user_permissions' },
        component: loadView('roles/RoleForm'),
      },
      {
        path: 'roles/:role_id',
        name: 'settings-role-edit',
        props: true,
        meta: { feature: 'user_permissions' },
        component: loadView('roles/RoleForm'),
      },
      {
        path: 'users/create',
        name: 'users-create',
        props: true,
        meta: { feature: FEATURES.USERS },
        component: loadView('users/UserCreate'),
      },
      {
        path: 'users/:id',
        name: 'user-edit',
        props: true,
        meta: { feature: FEATURES.USERS },
        component: loadView('users/UserEdit'),
      },
      {
        path: 'users/:user_id/permissions/:type?',
        name: 'user-permissions',
        props: true,
        meta: { feature: FEATURES.USER_PERMISSIONS },
        component: loadView('permissions/SingleUserPermissions'),
      },
      {
        path: '/settings/account/plans',
        name: 'billing-plans',
        props: true,
        meta: { feature: FEATURES.ACCOUNT },
        component: loadView('account/Plans'),
      },
    ],
  },
];

export default settingsRoutes;
